<template>
  <div class="agents-userlist">
    <Row>
        <Col :xs="24" :sm="24">
            <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
                <FormItem>
                    <Input v-model="formItem.key" clearable placeholder="输入关键词查找..."></Input>
                </FormItem>
                <FormItem>
                    <Button type="primary" @click="renderTable('formItem')">查找</Button>
                </FormItem>
                <FormItem>
                    <Button type="success" @click="createAgentTradesMan()">新增</Button>
                </FormItem>
            </Form>
        </Col>
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
     <div style="margin: 10px;overflow: hidden">
        <div style="float: right;">
            <Page ref="listPage" :total="pages.total" :current="pages.page" :page-size="pages.size" show-elevator show-total @on-change="changePage()"></Page>
        </div>
    </div>

     <Modal v-model="showModalStatus" title="添加代理商" @on-ok="ok"  :width='800'>
         <Form :model="search_s" ref="search_s" :inline="true" action="javascript:void(0)">
            <FormItem>
                <Input v-model="search_s.key" clearable placeholder="输入名称查找..."></Input>
            </FormItem>
            <FormItem>
                <Button type="primary" @click="renderTable1('search_s')">查找</Button>
            </FormItem>
        </Form>
        <Table border :columns="columns2" ref="selection" :data="columns2List" :loading="dataloading" @on-selection-change="handleSelectRow()"></Table>
         <div style="margin: 10px;overflow: hidden">
            <div style="float: right;">
                <Page ref="listPage1" :total="pages1.total" :current="pages1.page" :page-size="pages1.size" show-elevator show-total @on-change="changePage1()"></Page>
            </div>
        </div>
    </Modal>


    <Modal v-model="showModalStatus" title="添加商户" @on-ok="ok"  :width='800'>
         <Form :model="search_s" ref="search_s" :inline="true" action="javascript:void(0)">
            <FormItem>
                <Input v-model="search_s.key" clearable placeholder="输入名称查找..."></Input>
            </FormItem>
            <FormItem>
                <Button type="primary" @click="renderTable1('search_s')">查找</Button>
            </FormItem>
        </Form>
        <Table border :columns="columns2" ref="selection" :data="columns2List" :loading="dataloading" @on-selection-change="handleSelectRow()"></Table>
         <div style="margin: 10px;overflow: hidden">
            <div style="float: right;">
                <Page ref="listPage1" :total="pages1.total" :current="pages1.page" :page-size="pages1.size" show-elevator show-total @on-change="changePage1()"></Page>
            </div>
        </div>
    </Modal>

  </div>
</template>

<script>
import UploadThumb from "../common/thumb"
import uploadthumbTwo from "../common/thumb"
import UEditor from '../common/ueditor';
export default {
    name: 'agents-userlist',
    data () {
        return {
            id: null,   // 页面agentid
            loading: true,
            dataloading: true,
            title:"",
            pages:{
                page:1,
                size:10
            },
            formItem:{
                'key':'',
            },
            tablelist1:[],
            columns2:[
                {
                  type: 'selection',
                  width:100,
                  fixed: 'left'
                },
                {
                    title: '代理商UUID',
                    key: 'agent_uuid',
                    minWidth:100
                },
                // {
                //     title: '手机号',
                //     key: 'user',
                //     minWidth:100,
                //     render:(h,params) => {
                //         return h('span',params.row.user != null ? params.row.user.username : '')
                //     }
                // },
                {
                    title: '名称',
                    key: 'name',
                    minWidth:160,
                    // render:(h,params) => {
                    //     return h('span',params.row.tradesman != null ? params.row.tradesman.nickname : '')
                    // }
                },
            ],
            columns2List:[],
            pages1:{
                page:1,
                size:10
            },
            search_s:{},
            list: [
                {
                    title: '用户ID',
                    key: 'agent_uuid',
                    minWidth:350,
                },
                // {
                //     title: '用户身份',
                //     key: 'nickname',
                //     minWidth:160,
                //     render:(h,params) => {
                //         return h('span',params.row.tradesman != null ? params.row.tradesman.nickname : '')
                //     }
                // },
                {
                    title: '电话',
                    key: 'username',
                    minWidth:120,
                    render:(h,params) => {
                        return h('span',params.row.user!=null && params.row.user.username!=null ? params.row.user.username:'')
                    }
                },
                {
                    title: '用户名称',
                    key: 'name',
                    minWidth:200,
                },
            ],
            tablelist: [],
            showModalStatus:false,
        }
    },
    created: function () {
            this.id = this.$route.params.id;
            this.getTableList();
            // this.getCateList();
            // this.getSkillList();
            // this.getItemList();
    },
    components: {
        UploadThumb,
        // EditorBar,
        uploadthumbTwo,
        UEditor
    },
    watch:{
        "$route.params.id":function(curVal, oldVal) {
            if (curVal) {
                this.id = curVal;
                this.getTableList();
            }
        }
    },
    methods:{
        getTableList:function(){
          this.$api.partners.agentlist({"page":this.pages.page,"size":this.pages.size,id:this.id}).then(res=>{
            this.dataloading = false;
            if(res.code == 200)
            {
                this.tablelist = res.result.list;
                this.pages.total = res.result.total;
                this.$Message.success(res.msg);
            }
          });
          return;
        },
         // 翻页
        changePage() {
            this.pages.page = this.$refs['listPage'].currentPage;
            this.renderTable(1);
        },
        // 筛选
        renderTable:function(name) {
            if (name !=1){
                this.pages.page = 1;
             }
            this.dataloading = true;
            var ps = {
                key:this.formItem.key,
                page:this.pages.page,
                size:this.pages.size,
                id:this.id
            };
            this.$api.partners.agentlist(ps).then(res=>{
                this.dataloading = false;
                if(res.code == 200)
                {
                    this.tablelist = res.result.list;
                    this.pages.total = res.result.total;
                    this.$Message.success(res.msg);
                }
            });
            return;
        },
        createAgentTradesMan(){
            this.search_s.key = "";
            this.showModalStatus =true;
            this.$api.partners.noBindAgents({id:this.id}).then(res=>{
                if(res.code == 200)
                {
                    this.columns2List = res.result.list;
                    this.pages1.total = res.result.total;
                    this.$Message.success(res.msg);
                }
            });
        },
        // 筛选
        renderTable1:function(name) {
            if (name !=1){
                this.pages1.page = 1;
             }
            this.dataloading = true;
            var ps = {
                key:this.search_s.key,
                page:this.pages1.page,
                size:this.pages1.size,
                id:this.id
            };
            this.$api.partners.noBindAgents(ps).then(res=>{
                this.dataloading = false;
                if(res.code == 200)
                {
                    this.columns2List = res.result.list;
                    this.pages1.total = res.result.total;
                    this.$Message.success(res.msg);
                }
            });
            return;
        },
        handleSelectRow(selection, index) {
            this.selected = this.$refs.selection.getSelection();
            console.log(this.selected);
        },
        //选中提交
        ok () {
            this.tablelist1 = this.selected;
            this.$api.partners.agentCreate({partner_uuid:this.id,agentUuidArrs:this.selected}).then(res=>{
                if(res.code == 200)
                {
                    this.getTableList();
                    this.$Message.success(res.msg);
                    this.showModalStatus = false;
                }else{
                    this.$Message.error(res.msg);
                }
            });

        },
        changePage1() {
            this.pages1.page = this.$refs['listPage1'].currentPage;
            this.renderTable1(1);
        },

    },
}
</script>

<style>
    .demo-drawer-footer{
        width: 100%;
        height: 50px;
        position: absolute;
        bottom: 0;
        left: 0;
        border-top: 1px solid #e8e8e8;
        padding: 10px 16px;
        text-align: right;
        background: #fff;
    }
</style>
